import React from 'react';
import { Radio, Select, Input, Switch, Row, Col, message } from 'antd'
import { InputType, WidthType, RegularExpression } from './input-const';

const RadioGroup = Radio.Group;
const Option = Select.Option;

/**
 * 开关选择器输入控件配置组件
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-02-07 09:36:29
 * Version: 1.0
 * Modify log:
 */
class SettingSwitch extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            feature: '', //原参数json字符串
            featureParams: {
                type: InputType.SWITCH, //控件类型，必须有此属性，用于渲染时期判断控件类型
                checkedText: '',//开启时的文字说明
                uncheckedText: '', //关闭时的文字说明
                defaultChecked: false //是否开启
            }
        }
    }

    static defaultProps = {
        initFeature: ''
    }

    //在渲染前调用,可在此最后一次初始化组件状态
    componentWillMount() {
        //将输入控件配置参数设置到状态中
        if (this.props.initFeature) {
            try {
                let initFeature = JSON.parse(this.props.initFeature);
                if (initFeature.type == InputType.SWITCH) {
                    let { checkedText = '', uncheckedText = '', defaultChecked = false } = initFeature;

                    const fp = { ...this.state.featureParams };
                    fp.checkedText = checkedText;
                    fp.uncheckedText = uncheckedText;
                    fp.defaultChecked = defaultChecked;

                    this.setState({
                        feature: this.props.initFeature,
                        featureParams: fp
                    });
                }

            } catch (e) {
                console.log(e);
                message.error('解析控件配置参数出错！');
            }
        } else {
            try {
                let feature = JSON.stringify(this.state.featureParams);
                this.setState({
                    feature: feature
                });
            } catch (e) {
                console.log(e);
                message.error('生成控件配置参数出错！');
            }
        }
    }

    //供父组件获取feature
    getFeature = () => {
        return this.state.feature;
    }

    //当开关开启文字说明改变时
    handleCheckedTextChange = (e) => {
        let checkedText = e.target.value;
        const fp = { ...this.state.featureParams };
        fp.checkedText = checkedText;
        this.setState({ featureParams: fp });
        this.createFeature(fp);
    }

    //当开关关闭文字说明改变时
    handleUncheckedTextChange = (e) => {
        let uncheckedText = e.target.value;
        const fp = { ...this.state.featureParams };
        fp.uncheckedText = uncheckedText;
        this.setState({ featureParams: fp });
        this.createFeature(fp);
    }

    //当默认状态改变时
    handleDefaultCheckedChange = (value) => {
        let defaultChecked = value;
        const fp = { ...this.state.featureParams };
        fp.defaultChecked = defaultChecked;
        this.setState({ featureParams: fp });
        this.createFeature(fp);
    }

    //生成feature参数json字符串
    createFeature = (featureParams) => {

        try {
            let feature = JSON.stringify(featureParams);
            this.setState({
                feature: feature
            });
            this.props.onChange(feature);
        } catch (e) {
            console.log(e);
            message.error('生成控件配置参数出错！');
        }
    }

    render() {

        let { checkedText, uncheckedText, defaultChecked } = this.state.featureParams;

        return (
            <div id="input-setting-div">
                <Row type="flex">
                    <Col><div style={{ margin: "16px 0" }}>开关文字说明</div></Col>
                </Row>
                <Row type="flex" gutter={8}>
                    <Col span={12}>
                        <Input placeholder="请输入开启文字说明" value={checkedText} onChange={this.handleCheckedTextChange} />
                    </Col>
                    <Col span={12}>
                        <Input placeholder="请输入关闭文字说明" value={uncheckedText} onChange={this.handleUncheckedTextChange} />
                    </Col>
                </Row>
                <Row type="flex">
                    <Col span={24}><div style={{ margin: "16px 0" }}>默认状态</div></Col>
                </Row>
                <Row type="flex">
                    <Col span={12}>
                        <Switch checkedChildren={checkedText} unCheckedChildren={uncheckedText} checked={defaultChecked} onChange={this.handleDefaultCheckedChange} />
                    </Col>
                </Row>
            </div>
        )
    }
}

export default SettingSwitch;


// WEBPACK FOOTER //
// ./components/common/NHInputPicker/setting-switch.js